/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../common/breadcrumb";
// import { Link } from 'react-router-dom'
//import data from "../../assets/data/listVendor";
//import Datatable from "../common/datatable";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
// import { useSelector, useDispatch } from 'react-redux'
// import { adminInstance } from '../../config/axios'
// import { getAllRarityList } from '../../../reducers/adminReducers'
import ListDatatable from "./listdatatable";
import ConfirmationPopUp from "../common/ConfirmationPopUp";
// import { toast } from 'react-toastify'
// import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux";
import { getOrders, updateOrders } from "../../reducers/adminReducers";
import { toast } from "react-toastify";
import Loader from "../loader/loader";
import NoDataFound from "../Generik/NoDataFound";
// import InvoicePopUp from './invoice';
const InventoryManagement = () => {
  const dispatch = useDispatch();
  const result = useSelector((state) => state.admin);
  const { allOrders } = result || {};
  const [open, setOpen] = useState(false);
  const [activeId, setActiveId] = useState();
  const [dummy, setDummy] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({
    orderId: "",
    status: "",
    displayName: "",
    reason: "",
    shippedItems: "",
    trackOrderNumber: [],
  });
  const handleReason = (e) => {
    const { value, name } = e.target;
    const copy = { ...payload };
    copy[name] = value;
    setPayload(copy);
  };

  const handleTrackOrderId = (e, item) => {
    const { value } = e.target;

    setPayload((prev) => {
      const currentTrackNumbers = Array.isArray(prev.trackOrderNumber)
        ? [...prev.trackOrderNumber]
        : [];

      const index = currentTrackNumbers.findIndex(
        (entry) => entry.id === item._id
      );

      if (index !== -1) {
        currentTrackNumbers[index].trackNumber = value;
      } else {
        currentTrackNumbers.push({ id: item._id, trackNumber: value });
      }

      return {
        ...prev,
        trackOrderNumber: currentTrackNumbers,
      };
    });
  };

  const getOrdersData = async () => {
    setLoading(true);
    const response = await dispatch(getOrders());
    if (response?.payload) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOrdersData();
  }, [dummy]);
  const handleConfirm = async (id) => {
    setDummy(false);
    try {
      const newPayload = { ...payload };
      setOpen(false);
      setDummy(true);
      dispatch(updateOrders(newPayload)).then(() => {
        dispatch(getOrders());
      });
      toast.success("Order Status Updated Successfully", { toastId: "select" });
    } catch (error) {}
  };
  const onCloseModal = () => {
    setOpen(false);
    setActiveId(null);
  };

  const popopMessage =
    payload?.status === "shipped"
      ? "Please Enter Track Order Number."
      : `Are You Sure Want to ${payload?.displayName} Item ?`;

  return (
    <Fragment>
      <Breadcrumb title="Order List" parent="order" />
      <Container fluid={true}>
        <div className="admin-card">
          <Card>
            <CardHeader>
              <h5>Order Details</h5>
            </CardHeader>
            <CardBody>
              <div className="btn-popup pull-right"></div>
              <div className="clearfix"></div>
              <div
                id="batchDelete"
                className="category-table user-list order-table coupon-list-delete">
                {!loading ? (
                  allOrders.length > 0 ? (
                    <ListDatatable
                      multiSelectOption={true}
                      myData={allOrders}
                      pageSize={10}
                      pagination={true}
                      class="-striped -highlight"
                      setActiveId={setActiveId}
                      setOpen={setOpen}
                      setPayload={setPayload}
                    />
                  ) : (
                    <NoDataFound data="Order" />
                  )
                ) : (
                  <Loader />
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>
      <ConfirmationPopUp
        title={popopMessage}
        subtitle=""
        open={open}
        handleConfirm={handleConfirm}
        onCloseModal={onCloseModal}
        id={activeId}
        displayName={payload?.displayName}
        handleReason={handleReason}
        handleTrackOrderId={handleTrackOrderId}
        payload={payload}
      />
    </Fragment>
  );
};
export default InventoryManagement;
